<alert type="md-local">
  <strong>Well done!</strong> You successfully read this important alert message.
</alert>
